export enum DistributorKind {
  TravelAgency = 'TRAVEL_AGENCY',
  TourOperator = 'TOUR_OPERATOR',
}
